// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type LatestPricesResp } from '@shared/data-access/interfaces/api/commons';
import { equityApi } from '@advisor-app/store/api/brokerage/equity-api';
import { type AppDispatch } from '@advisor-app/store/store';

export const getLatestPrices = async (
  broker: any,
  data: string[],
  dispatch: AppDispatch,
): Promise<LatestPricesResp[]> => {
  const response: LatestPricesResp[] = [];

  const dataStocks = data.filter(ticker => !ticker.includes('-USD'));

  const params = {
    broker_key: broker.brokerConnected.toLowerCase(),
    type_account: broker.accountTypeSelect,
  };
  /* istanbul ignore if */
  if (dataStocks.length > 0) {
    const resp = await (broker.brokerConnected
      ? dispatch(
          equityApi.endpoints.prices.initiate({ params, tickers: dataStocks }),
        )
      : dispatch(equityApi.endpoints.citecPrice.initiate(dataStocks))
    ).unwrap();

    resp.forEach(assetPrice => {
      response.push({
        ...assetPrice,
        price: assetPrice.price ?? 0.000001,
      });
    });
  }
  return response;
};
